export default __webpack_public_path__ + "static/media/stock_plan_dark.6d015717.png";